export default __webpack_public_path__ + "static/media/nv2.b6788aa7.PNG";